import { Route } from "react-router";

import { CredentialRequestApproval } from "@/CredentialRequestApproval";
import { Goto } from "@/shared/navigation/Goto";
import { SignIn } from "@/SignIn";
import { SignUp } from "@/SignUp";

import { AuthenticationLayout } from "./AuthenticationLayout";

export function AuthenticationRoutes() {
  return [
    <Route key="signin" path="/signin" element={<SignIn />} />,
    <Route key="signup" path="/signup" element={<SignUp />} />,
    // Credential approval needs a signed-in person, without organization membership.
    <Route
      key="credentialRequests"
      element={<AuthenticationLayout isNotOrgProtected />}
    >
      <Route
        path={`${Goto.route.CredentialRequestApproval}/:credentialRequestId`}
        element={<CredentialRequestApproval />}
      />
    </Route>,
  ];
}
